// Set publicPath before any assets are loaded for iframe/CDN support
import './utils/publicPath';
import AAWindow from './components/aaWindow/aaWindow';
import AAConfig from './components/aaWindow/config/kore-config';

export {
  AAConfig,
  AAWindow
};
